module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "blq1"
  }, [_c('i', [_vm._v("“After it was all over I said some prayers for them, from the hymn book. That was the least that I could do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blq-right2"
  }, [_vm._v("—From a lengthy confession letter John Emil List left behind for his pastor before fleeing the home where he murdered his wife, his three children, and his mother")]), _vm._v(" "), _c('p', {
    staticClass: "blq1"
  }, [_c('i', [_vm._v("“The concept of the psychopath is, in fact, an admission of failure to solve the mystery of evil. It is merely a restatement of the mystery—and only offers an escape valve for the frustration felt by psychiatrists, social workers, and police officers, who daily encounter its force.”")])]), _vm._v(" "), _c('p', {
    staticClass: "blq-right2"
  }, [_vm._v("—Janet Malcolm, "), _c('i', [_vm._v("The Journalist and the Murderer")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 72
// module chunks = 0